import loadable from '@loadable/component';
import { WithLazyHydration } from '../../WithLazyHydration';

const ImageCarouselLoadable = loadable(() => import('./ImageCarousel'), {
  resolveComponent: components => components.ImageCarousel
});

export const ImageCarousel = WithLazyHydration(ImageCarouselLoadable, {
  name: 'ImageCarousel'
});
